import { apiRoutes } from '../../api-routes';
import { epApiUrl } from '../../constants';
import { type AxiosRequestConfig, httpClient } from '../../util';
import { detailResponseToAddress } from './utils';

export interface DetailResponse {
  address_components: AddressComponent[];
  formatted_address: string;
  geometry: GeometryDetail;
  place_id: string;
  plus_code: PlusCode;
  types: string[];
  sessiontoken: string;
  fromCache: boolean;
}

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface Viewport {
  northeast: any; // Location
  southwest: any; // Location
}

interface GeometryDetail {
  location: {
    lat: number;
    lng: number;
  };
  location_type: string;
  viewport: Viewport;
}
interface PlusCode {
  compound_code: string;
  global_code: string;
}

export interface DetailParams {
  place_id: string;
  sessiontoken?: string;
  address?: string;
}

export const getAddressFn = async (
  params: DetailParams,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.get<DetailResponse>(
    epApiUrl + apiRoutes.place.detail,
    {
      params,
      ...config,
    }
  );
  return detailResponseToAddress(response.data);
};
